<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses">

    <router-view @setAppClasses="setAppClasses"/>
  </div>
  <!-- <link rel="stylesheet" href="https://unpkg.com/leaflet-geosearch@2.6.0/assets/css/leaflet.css"> -->
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import {getUserAuth} from "./api/auth";
import {setUserData} from "./utils/auth";
import {mapState} from "vuex";

export default {
  data() {
    return {
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  computed: {
    ...mapState("objects", ["filters"]),
  },

  methods: {

    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },

    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  mounted() {


    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },

  async created() {
    let filtersLocalStorage = JSON.parse(localStorage.getItem("filter"));
    if (filtersLocalStorage) {
      this.$store.commit("objects/SET_FILTER", {
        source: {
          name: filtersLocalStorage.source_id.name,
          id: filtersLocalStorage.source_id.id,
        },
        normative_value: {
          name: filtersLocalStorage.normative_value.name,
          id: filtersLocalStorage.normative_value.id,
        },
      });
    }

    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || []
    window.addEventListener("resize", this.handleWindowResize);
    // await this.fetchRolePermissions(userInfo.permission)
    window.addEventListener("scroll", this.handleScroll);
    getUserAuth()
      .then((res) => {
        this.$store.commit("auth/SET_AUTH_USER_PROFILE", res.data);
        this.$store.commit("UPDATE_USER_INFO", {...res.data, permissions: userInfo.permissions});
        setUserData(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  }
}
</script>
<style>
.uppercase div {
  text-transform: uppercase;
}

.uppercase {
  text-transform: uppercase;
}

.vgt-responsive {
  padding: 0 1px;
}

.vs__dropdown-option--selected {
  background-color: rgb(0, 118, 166) !important;
  color: white !important;
}

.vs__dropdown-option:hover {
  background-color: rgb(0, 118, 166) !important;
}

.vs__dropdown-option:active {
  background-color: rgb(0, 118, 166) !important;
}

.bg__overlay {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  width: 100%;
  background-color: #f6f6f6;
  backdrop-filter: blur(2px);
  inset: 0;
  opacity: 0.85;
  height: 100%;
  text-align: center;
}
</style>
